import { useTheme, useMediaQuery } from "@mui/material";
import { RESPONSIVE_PADDING } from "../constants/Defaults.constants";

export const useResponsivePadding = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

  return {
    isMobile,
    mainContainer: isMobile ? RESPONSIVE_PADDING.MOBILE : isTablet ? RESPONSIVE_PADDING.TABLET : RESPONSIVE_PADDING.DESKTOP,
    bannerContainer: isMobile ? RESPONSIVE_PADDING.MOBILE_BANNER : RESPONSIVE_PADDING.DESKTOP_BANNER,
    contentContainer: isMobile ? RESPONSIVE_PADDING.MOBILE_CONTENT : RESPONSIVE_PADDING.DESKTOP_CONTENT,
  };
}; 